import script from "./CourtesyRepullDatesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourtesyRepullDatesCard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/card-rizz.css?vue&type=style&index=0&id=9a546e00&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a546e00"]])

export default __exports__